export default __webpack_public_path__ + "static/media/slide26.dfdcf7e5.png";